import { render } from "./ProjectList.vue?vue&type=template&id=85ade0d0&scoped=true"
import script from "./ProjectList.vue?vue&type=script&lang=js"
export * from "./ProjectList.vue?vue&type=script&lang=js"

import "./ProjectList.vue?vue&type=style&index=0&id=85ade0d0&scoped=true&lang=css"
import "./ProjectList.vue?vue&type=style&index=1&id=85ade0d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85ade0d0"]])

export default __exports__